<script>
    import Login from '../users/login.svelte'
</script>

<style>
    .border {
        width: 100vw;
        height: 100vh;
    }
    .center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }
</style>

<div class="border">
    <div class="center">
        <Login />
    </div>
</div>